import Templater from '@hc-frontend/shared-assets/src/js/utils/dom/Templater'
import moneyFormat from 'utils/format/money'
import innerHTML from 'utils/DOM/innerHTML'
import getById from 'utils/DOM/getById'

function renderBoxes({ plans, carriers }, maxPlansToCompare) {
  const boxTemplate = Templater(getById('template-compare-box').textContent)
  const boxesWrap = getById('compare-boxes')
  const emptyBox = {
    cardClass: 'compare-boxes__card--empty'
  }
  return plansToCompare => {
    const boxes = []
    for (let idx = 0; idx < maxPlansToCompare; idx++) {
      let planFound = emptyBox

      if (plansToCompare[idx]) {
        const [planId, period, recurrence] = plansToCompare[idx].split('-')
        const plan = plans[planId]
        const carrier = carriers[plan.carrierId]

        const policy = period
          ? plan.durations[period][recurrence || '1']
          : plan.durations[0]
        const fee = policy.monthly.fees
          .filter(({ name }) => name === 'Application Fee')
          .reduce((acc, fee) => acc + fee.value, 0)

        planFound = {
          ...plan,
          period,
          monthlyPremium: moneyFormat(policy.monthly.premium),
          fee,
          carrier,
          cardClass: 'compare-boxes__card--full',
          id: plansToCompare[idx]
        }
      }

      boxes.push(boxTemplate(planFound))
    }

    innerHTML(boxesWrap, boxes.join(''))
  }
}

export default renderBoxes
